import Axios from './axios_wrapper'

export function uploadImageForSharing(data) {
  return Axios({
    url: '/sharing',
    method: 'POST',
    data
  })
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/api/sharing.js
// module id = null
// module chunks = 